import { type FC } from "react"

const NotFoundPage: FC = () => <h1>404 - Page Not Found</h1>

export default NotFoundPage
